<div class="vehicle-wrapper">
  <div class="top-header">
    <h3>Add Vehicle</h3>
    <p>Please fill in all required fields</p>
  </div>
  <form [formGroup]="addVehicleForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-item">
        <label for="empId">Employee ID (Max 10 Characters) <small>*</small></label>
        <input formControlName="empId" type="text" id="empId" maxlength="10">
        <div  class="error" *ngIf="addVehicleForm.get('empId')?.invalid && addVehicleForm.get('empId')?.touched">
          <small *ngIf="addVehicleForm.get('empId')?.errors?.['required']">Employee ID is required.</small>
          <small *ngIf="addVehicleForm.get('empId')?.errors?.['minlength']">Minimum 3 characters required.</small>
          <small *ngIf="addVehicleForm.get('empId')?.errors?.['maxlength']">Maximum 10 characters required.</small>
        </div>
      </div>
      <div class="form-item">
        <label for="personName">Person Name (Max 20 Characters) <small>*</small></label>
        <input formControlName="personName" id="personName" maxlength="20">
        <!-- <div class="error" *ngIf="personName?.invalid && personName?.touched">
          Person Name is required
        </div> -->
        <div  class="error" *ngIf="addVehicleForm.get('personName')?.invalid && addVehicleForm.get('personName')?.touched">
          <small *ngIf="addVehicleForm.get('personName')?.errors?.['required']">Person Name is required</small>
        </div>
      </div>
      
    <!-- </div> -->
    <!-- <div class="form-2"> -->
      <div class="form-item">
        <label for="vehicleNo">Vehicle Number (Max 10 Characters) <small>*</small></label>
        <input formControlName="vehicleNo" id="vehicleNo" maxlength="10">
        <!-- <div class="error" *ngIf="vehicleNo?.invalid && vehicleNo?.touched">
          Vehicle Number is required
        </div> -->
        <div  class="error" *ngIf="addVehicleForm.get('vehicleNo')?.invalid && addVehicleForm.get('vehicleNo')?.touched">
          <small *ngIf="addVehicleForm.get('vehicleNo')?.errors?.['required']">Vehicle Number is required</small>
        </div>
      </div>
      <div class="form-item">
        <label for="vehicleType">Vehicle Type <small>*</small></label>
        <select formControlName="vehicleType" id="vehicleType">
          <!-- <option>Select Vehicle Type</option> -->
          <option *ngFor="let option of vehicleChoice" [value]="option">{{ option }}</option>
        </select>
        <!-- <div class="error" *ngIf="vehicleType?.invalid && vehicleType?.touched">
          Vehicle type is required
        </div> -->
        <div  class="error" *ngIf="addVehicleForm.get('vehicleType')?.invalid && addVehicleForm.get('vehicleType')?.touched">
          <small *ngIf="addVehicleForm.get('vehicleType')?.errors?.['required']">Vehicle type is required</small>
        </div>
      </div>
    <!-- </div> -->
    <!-- <div class="form-2"> -->
      <div class="form-item">
        <label for="mobileNo">Mobile Number (Country Code & 10 Digits) <small>*</small></label>
        <input formControlName="mobileNo" id="mobileNo" maxlength="13">
        <!-- <div class="phone-input">
          <select formControlName="countryCode" id="countryCode" class="country-code">
            <option *ngFor="let option of contryCode" [value]="option">{{ option }}</option>
          </select>
          <input formControlName="mobileNo" id="mobileNo" maxlength="10" (input)="validateNumericInput($event)">
        </div> -->
        <div class="error" *ngIf="addVehicleForm.get('mobileNo')?.invalid && addVehicleForm.get('mobileNo')?.touched">
          <small *ngIf="addVehicleForm.get('mobileNo')?.errors?.['required']">Mobile Number is required</small>
          <small *ngIf="addVehicleForm.get('mobileNo')?.errors?.['pattern']">Enter a valid 10-digit Mobile Number</small>
        </div>
      </div>
      <div class="form-item">
        <label for="comments">Comments (Max 50 Characters)</label>
        <input formControlName="comments" id="comments" maxlength="50">
      </div>
    </div>
    <div class="button-row">
      <button type="submit" class="btn-save">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon> ADD
      </button>
      <button type="button" class="btn-cancel" (click)="onCancel()">
        <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
      </button>
    </div>
    <!-- <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div> -->
  </form>
</div>